//ENROLLMENTS
export const FETCH_VID_ENGAGEMENT = "fetchvidengagement";
export const ADD_VID_ENGAGEMENT = "addvidengagement";
export const UPDATE_VID_ENGAGEMENT = "updatevidengagement";
